import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface MemberOnlyRouteProps {
  children: React.ReactNode;
}

export default function MemberOnlyRoute({ children }: MemberOnlyRouteProps) {
  // Get user from auth context
  const { user } = useAuth();
  
  // Check if user is authenticated
  if (!user || !localStorage.getItem('token')) {
    return <Navigate to="/signin" replace />;
  }

  // Allow all authenticated users to access StoreHub
  // This includes owners, members, admins, and managers
  return <>{children}</>;
}
